import ActionLink from '../../../Components/Dashboard/ActionLink';
import useDashboardSubject from '../../../Hooks/useDashboardSubject';
import DashboardRoot from '../../../Components/Dashboard/DashboardRoot';
import PageHead from '../../../Components/Dashboard/PageHead';
import DashboardGrid from '../../../Components/Dashboard/DashboardGrid';
import { formatShortDate } from '../../../Utils/dates/formatDate';
import { isoWeekNumber } from '../../../Utils/dates/localDay';
import useCoachRoutes from './useCoachRoutes';
import AthleteActivityCard from './athleteActivity/AthleteActivityCard';
import WeekPlanCard from './weekPlan/WeekPlanCard';
import GroupsProgramsCard from './groupsPrograms/GroupsProgramsCard';

export default function DashboardPage({ now: nowProp }) {
    const { id: coachId } = useDashboardSubject('coach');
    const routes = useCoachRoutes();
    const now = nowProp || new Date();
    const year = now.getFullYear();

    return (
        <DashboardRoot>
            <PageHead
                crumb={`Week ${isoWeekNumber(now)} · ${formatShortDate(now)} ${year}`}
                title="Squad overview"
                actions={
                    <>
                        <ActionLink to={routes.groups}>Assign program</ActionLink>
                        <ActionLink to={routes.programs}>New workout</ActionLink>
                    </>
                }
            />
            <DashboardGrid
                fold={<AthleteActivityCard coachId={coachId} now={nowProp} />}
                stack={[
                    <WeekPlanCard key="week" coachId={coachId} now={nowProp} />,
                    <GroupsProgramsCard key="groups" coachId={coachId} />
                ]}
            />
        </DashboardRoot>
    );
}
